import React, { Component } from 'react';
import './Maintenance.css'

class Maintenance extends Component {
    constructor(props) {
        super(props);
        this.state = {
          maintenanceMessage: ''
        }
      }

    componentDidMount(){
        fetch('properties/findByName?name=MaintenanceMessage',{
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
            }
        }).then(response =>{
            return response.json()
        }).then(data =>{
            this.setState({
                maintenanceMessage: data.value
            })
        })
    }
    render() {
        return (
            <div className='maintenanceContainer'>
                <h1 className='maintenanceText'>{this.state.maintenanceMessage}</h1>
            </div>
        );
    }
}

export default Maintenance;


// WEBPACK FOOTER //
// ./src/main/resources/js/components/Maintenance.js